import { createSelector } from 'reselect';
import { IADICategory } from '../../api/adiCategories/adiCategories';
import { IRootState, Selector } from '../rootReducer';
import { VideoType } from './types';
import type { IVideoInfoState } from './types';

const getVideoInfo = (state: IRootState): IVideoInfoState => state.videoInfo;

const getVideoType: Selector<VideoType | undefined> = createSelector(
  getVideoInfo,
  ({ videoType }) => videoType,
);

const getVideoPurpose: Selector<string | undefined> = createSelector(
  getVideoInfo,
  ({ videoPurpose }) => videoPurpose || undefined,
);

const isBusinessFlow: Selector<boolean> = createSelector(
  getVideoType,
  (videoType) => videoType === VideoType.BUSINESS,
);

const getBusinessName: Selector<string> = createSelector(
  getVideoInfo,
  ({ businessName }) => businessName || '',
);

const getBusinessCategory: Selector<IADICategory | undefined> = createSelector(
  getVideoInfo,
  ({ businessCategory }) => businessCategory,
);

const getPersonalCategory: Selector<IADICategory | undefined> = createSelector(
  getVideoInfo,
  ({ personalCategory }) => personalCategory,
);

const hasPersonalCategory: Selector<boolean> = createSelector(
  getPersonalCategory,
  (personalCategory) => !!personalCategory,
);

const getCategory: Selector<IADICategory | undefined> = createSelector(
  getBusinessCategory,
  getPersonalCategory,
  isBusinessFlow,
  (businessCategory, personalCategory, isBusiness) =>
    isBusiness ? businessCategory : personalCategory,
);

export {
  getVideoType,
  getVideoPurpose,
  getBusinessName,
  getCategory,
  getBusinessCategory,
  getPersonalCategory,
  hasPersonalCategory,
  isBusinessFlow,
};
